import { render, staticRenderFns } from "./taskResult.vue?vue&type=template&id=2874e5b6&scoped=true&"
import script from "./taskResult.vue?vue&type=script&lang=js&"
export * from "./taskResult.vue?vue&type=script&lang=js&"
import style0 from "./taskResult.vue?vue&type=style&index=0&id=2874e5b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874e5b6",
  null
  
)

export default component.exports